import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Site\GetSiteListController::__invoke
* @see app/Http/Controllers/Site/GetSiteListController.php
* @route '/api/site'
*/
const GetSiteListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSiteListController.url(options),
    method: 'get',
})

GetSiteListController.definition = {
    methods: ["get","head"],
    url: '/api/site',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Site\GetSiteListController::__invoke
* @see app/Http/Controllers/Site/GetSiteListController.php
* @route '/api/site'
*/
GetSiteListController.url = (options?: RouteQueryOptions) => {
    return GetSiteListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Site\GetSiteListController::__invoke
* @see app/Http/Controllers/Site/GetSiteListController.php
* @route '/api/site'
*/
GetSiteListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetSiteListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Site\GetSiteListController::__invoke
* @see app/Http/Controllers/Site/GetSiteListController.php
* @route '/api/site'
*/
GetSiteListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetSiteListController.url(options),
    method: 'head',
})

export default GetSiteListController